module.exports = __webpack_public_path__ + "img/Eo7.eb822b65.png";